let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ev3ZS")).then(() => parcelRequire('6vucW'));